import { mergeMap as e, filter as r, onPush as a, takeUntil as t, merge as o } from "wonka";

import { extractFiles as n } from "extract-files";

import { makeFetchBody as i, makeFetchURL as s, makeFetchOptions as c, makeFetchSource as p } from "@urql/core/internal";

var multipartFetchExchange = ({forward: d, dispatchDebug: u}) => f => {
  var h = e((e => {
    var o = r((r => "teardown" === r.kind && r.key === e.key))(f);
    var {files: d, clone: h} = n({
      ...e.variables
    });
    var l = i({
      query: e.query,
      variables: h
    });
    var m;
    var v;
    if (d.size) {
      m = s(e);
      if (!((v = c(e)).body instanceof FormData)) {
        if ("application/json" === v.headers["content-type"]) {
          delete v.headers["content-type"];
        }
        v.method = "POST";
        v.body = new FormData;
        v.body.append("operations", JSON.stringify(l));
        var y = {};
        var b = 0;
        d.forEach((e => {
          y[++b] = e.map((e => `variables.${e}`));
        }));
        v.body.append("map", JSON.stringify(y));
        b = 0;
        d.forEach(((e, r) => {
          v.body.append("" + ++b, r, r.name);
        }));
      }
    } else {
      m = s(e, l);
      v = c(e, l);
    }
    "production" !== process.env.NODE_ENV && u({
      type: "fetchRequest",
      message: "A fetch request is being executed.",
      operation: e,
      data: {
        url: m,
        fetchOptions: v
      },
      source: "multipartFetchExchange"
    });
    return a((r => {
      var a = !r.data ? r.error : void 0;
      "production" !== process.env.NODE_ENV && u({
        type: a ? "fetchError" : "fetchSuccess",
        message: `A ${a ? "failed" : "successful"} fetch response has been returned.`,
        operation: e,
        data: {
          url: m,
          fetchOptions: v,
          value: a || r
        },
        source: "multipartFetchExchange"
      });
    }))(t(o)(p(e, m, v)));
  }))(r((e => "query" === e.kind || "mutation" === e.kind))(f));
  var l = d(r((e => "query" !== e.kind && "mutation" !== e.kind))(f));
  return o([ h, l ]);
};

export { multipartFetchExchange };
//# sourceMappingURL=urql-exchange-multipart-fetch.mjs.map
